<template>
  <validation-observer ref="form" @change="onFormChange">
    <div class="row">
      <div class="col-12 col-md">
        <label class="data-title mb-2">Apodo:</label>
        <custom-input
          id="nickname"
          v-model="model.nickname"
          :disabled="readOnly"
        />
      </div>
      <div class="col-12 col-md">
        <label class="data-title mb-2">Idioma primario del estudiante:</label>
        <validation-provider
          v-slot="{ errors }"
          name="language"
          rules="required"
          mode="passive"
        >
          <custom-drop-down
            id="language"
            v-model="model.language"
            fieldkey="id"
            fieldname="name"
            :options="languages"
            placeholder="Seleccione"
            :error="errors[0]"
            custom-error-msg="El idioma primario del estudiante es requerido."
            @input="onFormChange"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
      <div class="col-12 col-md">
        <div v-if="isLanguageOther">
          <label class="data-title mb-2">Especifique el otro idioma:</label>
          <validation-provider
            v-slot="{ errors }"
            name="languageOther"
            rules="required"
            mode="passive"
          >
            <custom-input
              id="languageOther"
              v-model="languageOtherModel"
              :error="errors[0]"
              custom-error-msg="El idioma del estudiante es requeridos."
              :disabled="readOnly"
            />
          </validation-provider>
        </div>
      </div>
      <div class="col-12 col-md"></div>
    </div>
    <div class="row my-4">
      <div class="col-12 col-md-6">
        <label class="data-title mb-2">Dirección 1:</label>
        <custom-input
          id="address1"
          v-model="model.address1"
          :disabled="readOnly"
        />
      </div>
      <div class="col-12 col-md">
        <label class="data-title mb-2">Zip Code:</label>
        <custom-input
          id="zipCode"
          v-model="model.zipCode"
          type="text"
          mask-type="Zipcode"
          placeholder="#####"
          maxlength="10"
          :disabled="readOnly"
        />
      </div>
      <div class="col-12 col-md">
        <label class="data-title mb-2">Estado:</label>
        <p class="font-16 font-weight-normal">
          {{ model.state }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <label class="data-title mb-2">Dirección 2:</label>
        <custom-input
          id="address2"
          v-model="model.address2"
          :disabled="readOnly"
        />
      </div>
      <div class="col-12 col-md">
        <label class="data-title mb-2">Municipio:</label>
        <custom-drop-down
          id="municipality"
          v-model="model.municipality"
          fieldkey="id"
          fieldname="name"
          :options="municipalities"
          placeholder="Seleccione"
          @input="onFormChange"
          :disabled="readOnly"
        />
      </div>
      <div class="col-12 col-md">
        <label class="data-title mb-2">Teléfono:</label>
        <custom-input
          id="phone"
          v-model="model.phone"
          mask-type="Phone"
          placeholder="(###) ###-####"
          :disabled="readOnly"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from "@/components/common/CustomDropDown";
import CustomInput from "@/components/common/CustomInput";
import { Other as OTHER_LANG } from "@/utils/constants/codeLanguages.js";

export default {
  name: "VisualInpairmentsEnterRecordDemographicInfo",
  components: {
    CustomInput,
    CustomDropDown
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        nickname: null,
        languageId: null,
        languageName: null,
        address1: null,
        address2: null,
        zipCode: null,
        state: null,
        municipalityId: null,
        municipalityName: null,
        phone: null
      })
    },
    languages: {
      type: Array,
      required: true,
      default: () => []
    },
    municipalities: {
      type: Array,
      required: true,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      languageOtherModel: null
    };
  },
  methods: {
    onFormChange() {
      let languageId = this.model.language?.id;
      let languageName = this.model.language?.name;
      const isLanguageOther = languageId === OTHER_LANG.id;
      if (isLanguageOther) languageName = this.languageOtherModel;
      const value = {
        nickname: this.model.nickname,
        languageId,
        languageName,
        address1: this.model.address1,
        address2: this.model.address2,
        zipCode: this.model.zipCode,
        state: this.model.state,
        municipalityId: this.model.municipality?.id,
        municipalityName: this.model.municipality?.name,
        phone: this.model.phone
      };
      this.$emit("input", value);
    }
  },
  computed: {
    isLanguageOther() {
      return this.model.language?.id === OTHER_LANG.id;
    },
    model() {
      let language = {
        id: this.value.languageId,
        name: this.value.languageName
      };
      if (language.id == null) {
        if (language.name) language.id = OTHER_LANG.id;
        else language = null;
      }
      if (language?.id === OTHER_LANG.id) {
        this.languageOtherModel = language.name;
        language.name = null;
      }

      let municipality = {
        id: this.value.municipalityId,
        name: this.value.municipalityName
      };
      if (municipality.id == null) municipality = null;

      return {
        nickname: this.value.nickname,
        language,
        address1: this.value.address1,
        address2: this.value.address2,
        zipCode: this.value.zipCode,
        state: this.value.state,
        municipality,
        phone: this.value.phone
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_colors.scss";

label.data-title {
  color: map-get($colors, "black");
  font: normal normal bold 15px/18px Lato;
}
</style>
